import type { PostFormValues } from "./types";
import type { Post } from "@/partner/entities/posts";

/**
 * Maps GraphQL Post data to form values
 */
export const mapPostToFormValues = (post: Post): PostFormValues => {
  return {
    title: post.title || "",
    description: post.description ?? null,
    text: post.text ?? null,
    slug: post.slug ?? null,
    imageId: post.image?.id ?? null,
    tagIds: post.tags?.map((t) => t.id) ?? [],
    publishAt: post.publishAt ?? null,
    accessOnlyViaLink: post.accessOnlyViaLink ?? false,
  };
};
